// import { useWebSocket } from '@nile/home/src/hooks';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { connectSocket } from '@nile/home/public/workers/socketConnection';
import React, {
  useEffect,
  useContext,
  useRef,
  useState,
  Suspense
} from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { FitAddon } from 'xterm-addon-fit';
import { SearchAddon } from 'xterm-addon-search';
import { ResizableBox } from 'react-resizable';
import ResizeObserver from 'react-resize-observer';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { EventEmitter, Loader, AppContext } from '@nile/components';
import { Button, Banner, Term } from '@superops/ui-design-system';

let broadcastChannel;
if (BroadcastChannel) {
  broadcastChannel = new BroadcastChannel('SuperShare');
}

// const Term = React.lazy(() =>
//   import('@superops/ui-design-system').then((module) => ({
//     default: module.Term // Map the `Term` React component to default
//   }))
// );

const AssetTerminal = (props) => {
  let context = useContext(TicketContext);
  const appContext = useContext(AppContext);

  const { match } = props;
  const {
    assetId,
    termType,
    loginType,
    uniqueId,
    networkAssetId: urlNetworkAssetId
  } = match?.params;

  // Extract networkAssetId from URL path params or context data for backward compatibility
  const networkAssetId =
    urlNetworkAssetId || context?.activeTab?.data?.networkAssetId;

  const xtermRef = useRef(null);
  const [terminalErorr, setTerminalError] = useState(undefined);
  const [lastMessage, setLastMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sessionDisconnected, setSessionDisconnect] = useState(false);

  const [readyState, setReadyState] = useState();

  const determineFontHeight = function(fontStyle) {
    const body = document.getElementsByTagName('body')[0];
    const dummy = document.createElement('div');
    const dummyText = document.createTextNode('K');
    dummy.appendChild(dummyText);
    dummy.setAttribute('style', fontStyle);
    body.appendChild(dummy);
    const result = dummy.offsetHeight;
    body.removeChild(dummy);
    return result;
  };

  const getTextWidth = (font) => {
    const canvas =
      getTextWidth.canvas ||
      (getTextWidth.canvas = document.createElement('canvas'));
    const content = canvas.getContext('2d');
    content.font = font;
    const metrics = content.measureText('K');
    return metrics.width;
  };

  function calculateRows() {
    const family = xtermRef?.current?.terminal?.getOption('fontFamily');
    const size = xtermRef?.current?.terminal?.getOption('fontSize');
    const style = `font-family: ${family}; font-size: ${size}px;`;
    const rowHeight = family && size && determineFontHeight(style);

    const terminalBox = document
      .querySelector('.remoteTerminalBox')
      ?.getBoundingClientRect();

    return Math.ceil((terminalBox?.height - 20) / rowHeight);
  }

  function calculateCols() {
    const rows = xtermRef?.current?.terminal?.rows;

    const family = xtermRef?.current?.terminal?.getOption('fontFamily');
    const size = xtermRef?.current?.terminal?.getOption('fontSize');
    const font = `${size}px ${family}`;
    const colWidth = getTextWidth(font);
    const terminalBox = document
      .querySelector('.remoteTerminalBox')
      ?.getBoundingClientRect();

    return Math.ceil(terminalBox?.width / colWidth);
  }

  // const rows = calculateRows();
  // const rows =
  //   navigator.appVersion.indexOf('Win') > -1
  //     ? Math.round(screenHeight / 20.5)
  //     : Math.round(screenHeight / 18.5);
  // const cols = calculateCols();
  // const cols =
  //   navigator.appVersion.indexOf('Win') > -1
  //     ? Math.round(screenWidth / 7)
  //     : Math.round(screenWidth / 9);

  const rows = xtermRef?.current?.terminal?.rows;
  const cols = xtermRef?.current?.terminal?.cols;

  const [terminalSessions, setTerminalSessions] = useState(
    window.state.terminalSessions ? window.state.terminalSessions : {}
  );
  const [session, setSession] = useState({});

  if (
    match.path.indexOf('openterminal') > -1 &&
    context.activeTab === undefined
  ) {
    context = {
      activeTab: {
        id: 'one'
      }
    };
  }

  const searchAddon = new SearchAddon();
  const fitAddon = new FitAddon();

  const findSessionId = (vid, data) => {
    let id;
    const inTerminalSessions = window.state.terminalSessions.terminalSessions
      ? window.state.terminalSessions
      : terminalSessions;
    if (inTerminalSessions) {
      Object.keys(inTerminalSessions).find((g) => {
        if (
          terminalSessions[g] &&
          terminalSessions[g].id &&
          terminalSessions[g].id.indexOf(vid) > -1 &&
          data.windowId === `${assetId}remote-terminal`
        ) {
          id = terminalSessions[g].terminalId;
        }
      });
      return id;
    }
  };

  useEffect(() => {
    const activeSession = window.state.terminalSessions[context.activeTab.id];

    if (activeSession) {
      const history = activeSession.history;
      if (history && history.length > 0) {
        for (let i = 0; i < history.length; i++) {
          /** Check active tab is same as history action  */
          if (context.activeTab.id === history[i].tabId) {
            xtermRef?.current?.terminal.write(history[i].msg);
          }
        }
      }
    }
  }, [context?.activeTab.id]);

  useEffect(() => {
    if (lastMessage !== null) {
      let data = JSON.parse(lastMessage.data);

      if (data && data.context === 'terminal') {
        const { error } = data;
        const info = data.data;
        const action = data?.action;
        let tabId = data?.data?.id ? data?.data?.id : data?.action?.id;

        if (info && info.name === 'openterminal') {
          const newSession = {
            terminalId: info?.id,
            dstSessionId: info.dstSessionId,
            id: context.activeTab.id,
            history: []
          };

          terminalSessions[context?.activeTab.id] = newSession;

          if (
            terminalSessions[context?.activeTab.id]?.history.length === 0 &&
            action
          ) {
            action.tabId = context?.activeTab.id;
            terminalSessions[context?.activeTab.id]?.history.push(action);
          }
          xtermRef?.current?.terminal?.resize(cols, rows);
          setTerminalSessions(terminalSessions);
          setSession(newSession);
        }

        /* message with action property would be an  application action with respective context */
        if (action) {
          action.tabId = context?.activeTab.id;
          let terminalId = findSessionId(context.activeTab.id, data);
          if (terminalId === tabId) {
            xtermRef?.current?.terminal.write(action.msg);
          }

          if (terminalId === tabId) {
            terminalSessions[context?.activeTab.id]?.history.push(action);
          }
        }

        /* Websocket error handling */
        if (error) {
          setTerminalError(error);
          terminalSessions[context?.activeTab.id] = { error: error };
          if (error && error.code === 30001) {
            setTimeout(() => {
              broadcastChannel.postMessage(
                JSON.stringify({
                  name: 'wsdata',
                  data: {
                    context: 'heartbeat',
                    action: {
                      name: 'heartbeat'
                    }
                  }
                })
              );
              setTerminalError(undefined);
            }, 500);
          }
          setTerminalSessions(terminalSessions);
          setSession({ error: error });
        }
      }
    }
  }, [lastMessage]);

  const updateTabState = (eventData) => {
    xtermRef?.current?.terminal.write('\x1b[2K\r');
    xtermRef?.current?.terminal.clear();
    context.updateTabState(
      {
        terminalSessions: terminalSessions,
        history: history,
        session: session,
        scrollTop: document.querySelector('.xterm-viewport').scrollTop
      },
      eventData
    );
  };

  const closeTerminalSession = () => {
    const tabId = context.activeTab.id ? context.activeTab.id : session.id;
    if (tabId) {
      broadcastChannel.postMessage(
        JSON.stringify({
          name: 'wsdata',
          data: {
            context: 'terminal',
            dstSessionId: terminalSessions?.[tabId]?.dstSessionId,
            action: {
              name: 'closeterminal',
              id: terminalSessions[tabId]?.terminalId
            }
          }
        })
      );
      window.socket = false;
    }
  };

  const openTerminal = () => {
    const tabData = context?.activeTab?.data;
    const isNetworkDeviceTerminal = loginType === 'nm';

    // Base parameters common to all terminal types
    const baseParams = {
      name: 'openterminal',
      type: termType,
      rowsize: rows,
      columnsize: cols
    };

    // Build parameters based on terminal type
    let parameters;

    if (isNetworkDeviceTerminal) {
      // Network device terminal - only needs credentialId and ip
      parameters = {
        ...baseParams,
        credentialId: uniqueId,
        ip: tabData?.ipAddress
      };
    } else {
      // Standard terminal - includes user-related params from tabData
      parameters = {
        ...baseParams,
        loginas: tabData?.loginas || loginType,
        credentialId: tabData?.credentialId,
        sessionId: tabData?.sessionId,
        runAsAdmin: tabData?.runAsAdmin,
        username: tabData?.username,
        password: tabData?.password,
        domainName: tabData?.domainName
      };
    }

    broadcastChannel.postMessage(
      JSON.stringify({
        name: 'wsdata',
        data: {
          windowId: `${assetId}remote-terminal`,
          assetId: assetId, // this is probe id
          context: 'terminal',
          networkAssetId: networkAssetId, // this is asset id
          action: parameters
        }
      })
    );
  };

  broadcastChannel.onmessage = (event) => {
    if (event.data) {
      const type = JSON.parse(event.data).type;
      switch (type) {
        case 'WSState':
          const wsstate = JSON.parse(event.data);
          const state = wsstate?.hasOwnProperty('states')
            ? wsstate?.states?.find((el) => el?.connectionId === 'nile')
            : null;
          setReadyState(state || JSON.parse(event.data));
        default:
          setLastMessage(event);
      }
    }
  };

  useEffect(() => {
    /** fetch ready state */
    if (readyState?.state === 1) {
      setLoading(false);
      setSessionDisconnect(false);
    }
    if (readyState?.state === 3) {
      setLoading(false);
      setSessionDisconnect(true);
    }
  }, [readyState]);

  useEffect(() => {
    if (
      terminalSessions[context?.activeTab?.id] === undefined &&
      readyState?.state === 1
    ) {
      openTerminal();
    }
  }, [context?.activeTab?.id, readyState]);

  useEffect(() => {
    EventEmitter.subscribe('closeTab', closeTerminalSession);
    EventEmitter.subscribe('tabChange', updateTabState);
    /** fetch ready state */
    if (terminalSessions[context?.activeTab?.id] === undefined) {
      broadcastChannel.postMessage(
        JSON.stringify({
          name: 'init',
          action: {
            name: 'readystate'
          }
        })
      );
    }
    return function cleanup() {
      EventEmitter.unsubscribe('tabChange');
      EventEmitter.unsubscribe('closeTab');
    };
  }, []);

  // Use centralized banner visibility from AppContext
  const { bannerVisibility } = appContext;
  const isAnyBannerVisible = bannerVisibility?.isAnyBannerVisible || false;

  // Calculate height: subtract base height (70) + banner height (52) if any banner is visible
  const windowInnerWidth = window.innerWidth - 80;
  const windowInnerHeight =
    window.innerHeight - 70 - (isAnyBannerVisible ? 52 : 0);

  return (
    <div className="fh m10 remoteTerminalBox">
      <Suspense fallback={<Loader />}>
        <ResizableBox width={windowInnerWidth} height={windowInnerHeight}>
          <>
            {loading && readyState?.state !== undefined && (
              <div className="flex actr jctr w100 fh z99 position-absolute" />
            )}
            {sessionDisconnected && (
              <div className="flex actr jctr w100 fh z99 position-absolute">
                <Banner
                  title="Session disconnected"
                  status="info"
                  onDismiss={() => {}}
                >
                  <p>
                    Session disconnected{' '}
                    {
                      <span>
                        ,{' '}
                        <Button
                          id={'rmmTerminalReconnect'}
                          plain
                          onClick={connectSocket}
                        >
                          Click to Reconnect
                        </Button>
                      </span>
                    }
                  </p>
                </Banner>
              </div>
            )}
            {terminalSessions[context?.activeTab?.id]?.error && (
              <div className="flex actr jctr w100 fh z99 position-absolute">
                <Banner title="Session" status="info">
                  <p>
                    {terminalSessions[context?.activeTab?.id]?.error.msg},{' '}
                    {terminalSessions[context?.activeTab?.id]?.error &&
                      terminalSessions[context?.activeTab?.id]?.error.code !==
                        30004 && (
                        <span>
                          ,{' '}
                          <Button plain onClick={openTerminal}>
                            Click to Reconnect
                          </Button>
                        </span>
                      )}
                  </p>
                </Banner>
              </div>
            )}

            <Term
              addons={[searchAddon, fitAddon]}
              className={`terminal ${sessionDisconnected ? 'disabled' : ''}`}
              ref={xtermRef}
              options={{ rows: rows }}
              onData={(data) => {
                const tabId = context.activeTab.id;
                if (tabId) {
                  broadcastChannel.postMessage(
                    JSON.stringify({
                      name: 'wsdata',
                      data: {
                        context: 'terminal',
                        dstSessionId: terminalSessions[tabId]?.dstSessionId,
                        action: {
                          name: 'command',
                          command: data,
                          id: terminalSessions[tabId]?.terminalId,
                          keyevent: ''
                        }
                      }
                    })
                  );
                }
              }}
            />
            <ResizeObserver
              onResize={() => {
                fitAddon.fit();
              }}
            />
          </>
        </ResizableBox>
      </Suspense>
    </div>
  );
};

export default injectIntl(withRouter(withLDConsumer()(AssetTerminal)));
